import { useState, useRef, useEffect } from "react";
import styles from "../styles/Tabel.module.css";

export default function VoiceMessage({ voice }) {
  const [isPlaying, setIsPlaying] = useState(false);
  const [progress, setProgress] = useState(0);
  const [duration, setDuration] = useState(0);
  const [currentTime, setCurrentTime] = useState(0);
  const audioRef = useRef(null);

  useEffect(() => {
    const audio = new Audio(voice);
    audio.onloadedmetadata = () => {
      setDuration(audio.duration);
    };
  }, [voice]);

  const togglePlay = () => {
    if (isPlaying) {
      audioRef.current.pause();
    } else {
      audioRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };

  const formatTime = (seconds) => {
    if (isNaN(seconds)) return "0:00";
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins}:${secs < 10 ? "0" : ""}${secs}`;
  };

  return (
    <div className={styles.voiceMessageContainer}>
      <audio
        ref={audioRef}
        src={voice}
        onTimeUpdate={() => {
          setCurrentTime(audioRef.current.currentTime);
          setProgress((audioRef.current.currentTime / duration) * 100);
        }}
        onEnded={() => setIsPlaying(false)}
        hidden
      />

      <div className={styles.customAudioPlayer}>
        <button onClick={togglePlay} className={styles.playButton}>
          {isPlaying ? "❚❚" : "▶"}
        </button>

        <div className={styles.progressBar}>
          <div className={styles.progress} style={{ width: `${progress}%` }} />
        </div>

        <span className={styles.duration}>
          {formatTime(isPlaying ? currentTime : duration)}
        </span>
      </div>
    </div>
  );
}
